/**
 * Veridian Badge — marks modules/features certified by Veridian (authoring AI).
 *
 * Usage:
 *   <VeridianBadge />                        // default small icon
 *   <VeridianBadge variant="pill" />         // pill with text "Veridian"
 *   <VeridianBadge variant="pill" label="Veridian Certified" />
 *   <VeridianBadge tooltip="Integrated by Veridian asyncpg pool" />
 */
import React from "react";

type Variant = "icon" | "pill";

interface Props {
  variant?: Variant;
  label?: string;
  tooltip?: string;
  size?: number; // icon size in px, default 16
  className?: string;
}

export const VeridianBadge: React.FC<Props> = ({
  variant = "icon",
  label = "Veridian",
  tooltip = "Module integrated by Veridian",
  size = 16,
  className = "",
}) => {
  const logoSrc = "/brand/veridian_logo.png";

  if (variant === "pill") {
    return (
      <span
        title={tooltip}
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-xs font-medium ${className}`}
        style={{
          background: "rgba(189, 178, 255, 0.08)",
          borderColor: "rgba(189, 178, 255, 0.4)",
          color: "#bdb2ff",
        }}
      >
        <img
          src={logoSrc}
          alt="Veridian"
          width={size}
          height={size}
          style={{ objectFit: "contain" }}
        />
        <span>{label}</span>
      </span>
    );
  }

  return (
    <img
      src={logoSrc}
      alt="Veridian certified"
      title={tooltip}
      width={size}
      height={size}
      style={{ objectFit: "contain", verticalAlign: "middle", display: "inline-block" }}
      className={className}
    />
  );
};

export default VeridianBadge;
